export const MAINNET_URL = process.env.REACT_APP_MAINNET_URL;
export const GORLI = process.env.REACT_APP_GOERLI_URL;
